module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 3-f97aba4baa3f2f209c2658949f0ae8b0.jpg";